import { render, staticRenderFns } from "./Lp4.vue?vue&type=template&id=97aa7760&scoped=true"
import script from "./Lp4.vue?vue&type=script&lang=js"
export * from "./Lp4.vue?vue&type=script&lang=js"
import style0 from "./Lp4.vue?vue&type=style&index=0&id=97aa7760&prod&scoped=true&lang=scss"
import style1 from "./Lp4.vue?vue&type=style&index=1&id=97aa7760&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97aa7760",
  null
  
)

export default component.exports